var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classComponent},[_c('img',{staticStyle:{"max-height":"15vh"},attrs:{"src":_vm.imageFile}})])
}
var staticRenderFns = []

export { render, staticRenderFns }